var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.5H3.5V8H12.5V9.5ZM2 9.5H0.5V8H2V9.5ZM12.5 5.75H3.5V4.25H12.5V5.75ZM2 5.75H0.5V4.25H2V5.75ZM12.5 2H3.51725V0.5H12.5V2ZM2 2H0.5V0.5H2V2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveListView);
export default __webpack_public_path__ + "static/media/activeListView.457b48ef5ecad1a87184e0cfa9079c70.svg";
export { ForwardRef as ReactComponent };